import Client from "./client";

export const GetScopeTypes = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/scope-types`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scopeTypes);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateScopeType = ({projectId, name, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/scope-types`, {name}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scopeType);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const RenameScopeType = ({scopeTypeId, name, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/scope-types/${scopeTypeId}`, {name}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scopeType);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const ArchiveScopeType = ({scopeTypeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/scope-types/${scopeTypeId}/archive`, {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scopeType);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeleteScopeType = ({scopeTypeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/scope-types/${scopeTypeId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetScopes = ({projectId, scopeTypeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/scopes?scopeTypeId=${scopeTypeId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scopes);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateScope = ({projectId, scopeTypeId, name, description, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/scopes`, {scopeTypeId, name, description}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scope);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// `version`/`base` are how the API tells a save that changed something else
// touched in the meantime from one that's a real conflict - see PUT
// /scopes/:id. `base` only needs to carry the fields actually being sent
// (their value as this client originally loaded the item), not the whole
// record.
export const UpdateScope = ({scopeId, name, description, status, scopeTypeId, startdate, enddate, version, base, accessToken}) => {
    const body = {};
    if (name !== undefined) body.name = name;
    if (description !== undefined) body.description = description;
    if (status !== undefined) body.status = status;
    if (scopeTypeId !== undefined) body.scopeTypeId = scopeTypeId;
    if (startdate !== undefined) body.startdate = startdate;
    if (enddate !== undefined) body.enddate = enddate;
    if (version !== undefined) body.version = version;
    if (base !== undefined) body.base = base;

    return new Promise((resolve, reject) => {
        Client.put(`/api/scopes/${scopeId}`, body, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scope);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

export const SplitScope = ({scopeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/scopes/${scopeId}/split`, {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scope);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// Flips one description bullet's complete flag on its own, rather than
// PATCHing the whole scope item - see PUT /scopes/:id/description/:index.
// Used by every place a bullet's checkbox is clicked outside the Edit Scope
// modal (that one queues the change behind its own Save, same as every
// other field there).
export const ToggleScopeDescriptionItem = ({scopeId, index, complete, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/scopes/${scopeId}/description/${index}`, {complete}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scope);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

export const DeleteScope = ({scopeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/scopes/${scopeId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetDesignPage = ({projectId, typeSlug, scopeSlug, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/design/${typeSlug}/${scopeSlug}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// `version`/`base` are how the API tells a save that changed while this
// page was open from one that's a real conflict - see PUT
// /projects/:id/design/:typeSlug/:scopeSlug.
export const UpdateDesignPage = ({projectId, typeSlug, scopeSlug, body, version, base, accessToken}) => {
    const data = {body};
    if (version !== undefined) data.version = version;
    if (base !== undefined) data.base = base;

    return new Promise((resolve, reject) => {
        Client.put(`/api/projects/${projectId}/design/${typeSlug}/${scopeSlug}`, data, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.design_page);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

// Backs the document editor's internal-link picker (see
// components/Editor) - searches tickets, bugs, and design pages in one
// call. An empty query resolves to no results without hitting the API,
// since the backend treats one the same way.
export const SearchProject = ({projectId, query, accessToken}) => {
    return new Promise((resolve, reject) => {
        const q = (query || "").trim();
        if (!q) {
            resolve([]);
            return;
        }

        Client.get(`/api/projects/${projectId}/search`, {
            params: {q},
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.results);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong searching. Please try again." });
        })
    })
}

export const GetPhases = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/phases`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.phases);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreatePhase = ({projectId, name, startdate, enddate, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/phases`, {name, startdate, enddate}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.phase);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const UpdatePhase = ({phaseId, name, startdate, enddate, status, accessToken}) => {
    const body = {};
    if (name !== undefined) body.name = name;
    if (startdate !== undefined) body.startdate = startdate;
    if (enddate !== undefined) body.enddate = enddate;
    if (status !== undefined) body.status = status;

    return new Promise((resolve, reject) => {
        Client.put(`/api/phases/${phaseId}`, body, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.phase);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeletePhase = ({phaseId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/phases/${phaseId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const AttachPhaseScope = ({phaseId, scopeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/phases/${phaseId}/scopes`, {scopeId}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scope);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DetachPhaseScope = ({phaseId, scopeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/phases/${phaseId}/scopes/${scopeId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scope);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const MovePhaseScope = ({phaseId, scopeId, direction, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/phases/${phaseId}/scopes/${scopeId}/move`, {direction}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.scopes);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// The tickets under a phase, for the Roadmap's phase detail panel. A ticket
// reaches a phase through its scope item, so this is a server-side join rather
// than something the client can assemble from what it holds - see
// GET /phases/:id/tickets. Not paged: a phase's work is bounded, and the panel
// shows it whole.
export const GetPhaseTickets = ({phaseId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/phases/${phaseId}/tickets`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.tickets);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

// The tickets attached directly to one scope item - the narrower half of
// GetPhaseTickets, and what the Roadmap's scope detail panel lists. See
// GET /scopes/:id/tickets.
export const GetScopeTickets = ({scopeId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/scopes/${scopeId}/tickets`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.tickets);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}
